import { baseAPI } from '@/api/axios';
import { CUSTOM_FILTERS } from '@/api/endpoints';
import showAPIErrorToast from '@/utils/showAPIErrorToast';

const handleErrorResponse = (err, dispatch, disableRequestIndicator = false) => {
    if (!disableRequestIndicator) {
        showAPIErrorToast(err);
        dispatch('SET_API_RESPONSE_STATUS', 'error');
    }
};

const initialState = {
    jobFilters: [],
    selectedJobFilter: {},
    selectedJobFilterToEdit: {},
    customFilters: [],
    selectedCustomFilter: {},
};

const getters = {
    jobFilters: (state) => {
        return state.jobFilters;
    },
    customFilters: (state) => {
        return state.customFilters;
    },
    selectedJobFilter: (state) => {
        return state.selectedJobFilter;
    },
    selectedJobFilterToEdit: (state) => {
        return state.selectedJobFilterToEdit;
    },
    selectedCustomFilter: (state) => {
        return state.selectedCustomFilter;
    },
};

const mutations = {
    RESET_STATE(state) {
        Object.assign(state, initialState);
    },
    SET_JOB_FILTERS(state, jobFilters) {
        state.jobFilters = jobFilters;
    },
    SET_CUSTOM_FILTERS(state, customFilters) {
        state.customFilters = customFilters;
    },
    SET_SELECTED_JOB_FILTER(state, filter) {
        state.selectedJobFilter = filter;
    },
    SET_SELECTED_JOB_FILTER_TO_EDIT(state, filter) {
        state.selectedJobFilterToEdit = filter;
    },
    SET_SELECTED_CUSTOM_FILTER(state, filter) {
        state.selectedCustomFilter = filter;
    },
};

const actions = {
    RESET_STATE({ commit }) {
        commit('RESET_STATE');
    },
    SET_JOB_FILTERS({ commit }, value) {
        commit('SET_JOB_FILTERS', value);
    },
    SET_CUSTOM_FILTERS({ commit }, value) {
        commit('SET_CUSTOM_FILTERS', value);
    },
    SET_SELECTED_JOB_FILTER({ commit, dispatch }, value) {
        commit('SET_SELECTED_JOB_FILTER', value);
        commit('SET_SELECTED_CUSTOM_FILTER', {});
        dispatch('app/SET_FILTER_OPTIONS', value?.filters || {}, { root: true });
    },
    SET_SELECTED_JOB_FILTER_TO_EDIT({ commit }, value) {
        commit('SET_SELECTED_JOB_FILTER_TO_EDIT', value);
    },
    SET_SELECTED_CUSTOM_FILTER({ commit, dispatch }, value) {
        commit('SET_SELECTED_JOB_FILTER', {});
        commit('SET_SELECTED_CUSTOM_FILTER', value);
        dispatch('app/SET_FILTER_OPTIONS', value?.filters || {}, { root: true });
    },
    UPDATE_JOB_FILTER({ commit, dispatch, state }, jobFilter) {
        const { selectedJobFilter, jobFilters } = state;

        if (selectedJobFilter._id === jobFilter._id) {
            // updating in case applied job filter is modified
            dispatch('SET_SELECTED_JOB_FILTER', jobFilter);
        }

        const updatedJobFilters = jobFilters.map((filter) => {
            return filter._id === jobFilter._id ? jobFilter : filter;
        });
        commit('SET_JOB_FILTERS', updatedJobFilters);
    },
    async FETCH_JOB_FILTERS({ dispatch }) {
        await baseAPI
            .get(CUSTOM_FILTERS.JOB_FILTERS())
            .then(({ data }) => {
                dispatch('SET_JOB_FILTERS', data);
            })
            .catch((error) => {
                handleErrorResponse(error, dispatch);
            });
    },
    async FETCH_CUSTOM_FILTERS({ dispatch }) {
        await baseAPI
            .get(CUSTOM_FILTERS.ALL_FILTERS())
            .then(({ data }) => {
                dispatch('SET_CUSTOM_FILTERS', data);
            })
            .catch((error) => {
                handleErrorResponse(error, dispatch);
            });
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    mutations,
    actions,
};
